export { default as blueColor } from './blue';
export { default as greenColor } from './green';
export { default as greyColor } from './grey';
export { default as orangeColor } from './orange';
export { default as redColor } from './red';
